import { Card, Checkbox, LearnMoreLink, Text } from '@ui/themed';
import { t } from 'i18next';
import { SETTING_KEY_TO_LABEL } from '../../constants';
import { useCustomerGroupBuilderForm } from '../../hooks/use-customer-group-builder-form';
import { ResetSettingsButton } from './reset-settings-button';

export function CreditSettingsCard() {
  const form = useCustomerGroupBuilderForm();

  return (
    <Card showBorder>
      <Card.Header collapsible headingLevel="h2" icon="lock">
        {SETTING_KEY_TO_LABEL.paymentOnAccountEnforceCreditLimit}
      </Card.Header>
      <Card.Body>
        <Text variant="secondary">
          {t('features:customer_group.components.credit_settings_card.description')}{' '}
          <LearnMoreLink link="https://docs.sparklayer.io/credit-net-terms-and-invoicing" />
        </Text>
        <form.Field name="settings.paymentOnAccountEnforceCreditLimit">
          {(field) => (
            <>
              <Checkbox
                label={t(
                  'features:customer_group.components.credit_settings_card.prevent_if_exceeding.label',
                )}
                description={t(
                  'features:customer_group.components.credit_settings_card.prevent_if_exceeding.description',
                )}
                checked={!!field.state.value}
                onChange={() => field.handleChange((prev) => !prev)}
              />
              <div className="flex justify-start">
                <ResetSettingsButton field={field} />
              </div>
            </>
          )}
        </form.Field>
      </Card.Body>
    </Card>
  );
}
